const awradData = {
  title: "الأوراد",
  List: [
    {
      id: 1,
      name: "ورد الإستغفار",
      path: "/awrad",
    },
    {
      id: 2,
      name: "ورد الصلاة علي النبي",
      path: "/awrad",
    },
    {
      id: 3,
      name: "سبحان الله 100 مرة",
      path: "/awrad",
    },
    {
      id: 4,
      name: "سبحان الله وبحمده 100 مرة",
      path: "/awrad",
    },
    {
      id: 5,
      name: "سبحان الله وبحمده سبحان الله العظيم",
      path: "/awrad",
    },
    {
      id: 6,
      name:
        "سبحان الله والحمد لله ولا إله إلا الله والله اكبر ولا حول ولا قوة إلا بالله",
      path: "/awrad",
    },
  ],
};

export default awradData;
